const TOPICS = {};

function publish(topic, ...args) {
  const handlers = TOPICS[topic];
  if (handlers) {
    handlers.forEach(h => h(...args));
  }
}

function unsubscribe(topic, handler) {
  let handlers = TOPICS[topic];
  if (handlers) {
    const index = handlers.indexOf(handler);
    if (index >= 0) {
      handlers.splice(index, 1);
    }
  }
}

function subscribe(topic, handler) {
  let handlers = TOPICS[topic];
  if (!handlers) {
    handlers = [];
    TOPICS[topic] = handlers;
  }
  if (!handlers.includes(handler)) {
    handlers.push(handler);
  }
  return {
    unsubscribe: () => unsubscribe(topic, handler)
  };
}

const EventBus = {
  publish,
  subscribe,
  unsubscribe
};

export default EventBus;
